import React, { memo, useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import Logo from './components/Logo';
import NavigationLink from './components/NavigationLink';
import LoginButton from './components/LoginButton';
import NewVideoButton from './components/NewVideoButton';
import navigationItems from './utils/navigationItems';
import { ListItemButton } from '@mui/material';
import { isAdmin } from '../../utilities/userUtilities';

const drawerWidth = 220;

const useStyles = makeStyles()((theme) => ({
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        minHeight: 48,
    },
    bottomContainer: {
        position: 'absolute',
        bottom: theme.spacing(1),
        justifyContent: 'center',
        width: '100%',
        padding: 0
    },
    imageLink: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    newVideoContainer: {
        justifyContent: 'center'
    }
}));

const DesktopLayout = ({ loggedIn, logOutPress, logInPress, accountDetails, children }) => {
    const { classes } = useStyles();

    const ImageLink = React.forwardRef((props, ref) => (
        <Link ref={ref} to='/videos' {...props} />
    ));

    const filteredNavigationItems = useMemo(() => {
        const isUserAdmin = isAdmin(accountDetails?.roles);
        return navigationItems.filter(item => {
            if (item.roles && item.roles.length > 0) {
                return isUserAdmin;
            }
            return true;
        });
    }, [accountDetails]);

    return (
        <Box sx={{ display: 'flex' }}>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant='permanent'
                anchor="left">
                <div className={classes.toolbar}>
                    <ListItemButton divider className={classes.imageLink} component={ImageLink}>
                        <Logo width={128} height={30} />
                    </ListItemButton>
                </div>
                <List disablePadding>
                    <br />
                    <ListItem className={classes.newVideoContainer}>
                        <NewVideoButton />
                    </ListItem>
                    <br />
                    {filteredNavigationItems.map(item => (<NavigationLink key={item.path || item.label} item={item} />))}
                </List>
                <ListItem className={classes.bottomContainer}>
                    <LoginButton
                        loggedIn={loggedIn}
                        logOutPress={logOutPress}
                        logInPress={logInPress}
                    />
                </ListItem>
            </Drawer>
            <Box
                component="main"
                sx={{ flexGrow: 1, bgcolor: 'background.default' }}
            >
                {children}
            </Box>
        </Box>
    );
}

export default memo(DesktopLayout);